module.exports = __webpack_public_path__ + "static/img/manual-12.dd001f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-12.png
// module id = lgES
// module chunks = 4